// useDarkMode is now a thin compatibility shim over the multi-theme
// ThemeProvider. Existing components that call useDarkMode() keep working on
// the light/dark axis while the app migrates to CSS-var tokens. New code should
// prefer useTheme()/useIsDarkTheme() from ../theme/ThemeProvider.
import { DARK_THEME_IDS } from '../theme/tokens';
import { useTheme } from '../theme/ThemeProvider';

export function useDarkMode() {
  const { theme, setTheme } = useTheme();
  const isDarkMode = DARK_THEME_IDS.includes(theme);
  const toggleDarkMode = () => setTheme(isDarkMode ? 'light' : 'dark');
  return { isDarkMode, toggleDarkMode };
}

// Kept as a no-op passthrough: ThemeProvider is now the real provider (wired in
// App.js). This avoids breaking any stray `import { DarkModeProvider }`.
export function DarkModeProvider({ children }) {
  return children;
}
